import React from 'react'
import CreateBudget from 'src/app/CreateBudget/CreateBudget'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { createBudgetRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const CreateBudgetAppRoute: AppRoute = {
  id: AppLocation.CreateBudget,
  routeProps: createBudgetRouteProps,
  component: <CreateBudget />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default CreateBudgetAppRoute
